/**
 * 无需跨进程通信，通过nanoEvents实现双向通信
 */
import { createNanoEvents } from 'nanoevents';
class MegaTransport {
    constructor() {
        this.eventEmitterMap = new Map();
        this.publish = (payload) => {
            const { token, eventName, args } = payload;
            const channelEmitter = this.getEventEmitter(token);
            channelEmitter.emit(String(eventName), ...args);
        };
        this.subscribe = (token, eventName, handler) => {
            const channelEmitter = this.getEventEmitter(token);
            return channelEmitter.on(eventName, handler);
        };
        this.unsubscribe = (token) => {
            if (!this.eventEmitterMap.has(token)) {
                return;
            }
            this.getEventEmitter(token).events = {};
            this.eventEmitterMap.delete(token);
        };
    }
    /**
     * 不同 channel 使用独立 events 系统，channel 关闭时 events 事件系统清除
     * @param token
     * @returns
     */
    getEventEmitter(token) {
        if (!this.eventEmitterMap.has(token)) {
            this.eventEmitterMap.set(token, createNanoEvents());
        }
        return this.eventEmitterMap.get(token);
    }
}
export default MegaTransport;
//# sourceMappingURL=mega-transport.js.map